var _path, _rect, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuyOnline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 52,
    viewBox: "0 0 51 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33955 18.3817L25.6056 1.47792L48.8717 18.3817L39.9848 45.7326H11.2264L2.33955 18.3817Z",
    stroke: "#3D8ECC",
    strokeWidth: 1.4
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 27,
    width: 13,
    height: 5,
    fill: "#3D8ECC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 32V21.5H16.75V19.75H19.375C19.6071 19.75 19.8296 19.8422 19.9937 20.0063C20.1578 20.1704 20.25 20.3929 20.25 20.625V31.125H31.1332L32.8832 24.125H22V22.375H34.005C34.138 22.375 34.2693 22.4053 34.3888 22.4637C34.5083 22.522 34.613 22.6068 34.6948 22.7117C34.7766 22.8165 34.8335 22.9387 34.861 23.0688C34.8886 23.1989 34.8861 23.3336 34.8538 23.4626L32.6663 32.2126C32.6189 32.4018 32.5096 32.5698 32.3558 32.6898C32.202 32.8098 32.0126 32.875 31.8175 32.875H19.375C19.1429 32.875 18.9204 32.7828 18.7563 32.6187C18.5922 32.4546 18.5 32.2321 18.5 32ZM20.25 38.125C19.7859 38.125 19.3408 37.9406 19.0126 37.6124C18.6844 37.2842 18.5 36.8391 18.5 36.375C18.5 35.9109 18.6844 35.4658 19.0126 35.1376C19.3408 34.8094 19.7859 34.625 20.25 34.625C20.7141 34.625 21.1592 34.8094 21.4874 35.1376C21.8156 35.4658 22 35.9109 22 36.375C22 36.8391 21.8156 37.2842 21.4874 37.6124C21.1592 37.9406 20.7141 38.125 20.25 38.125ZM30.75 38.125C30.2859 38.125 29.8408 37.9406 29.5126 37.6124C29.1844 37.2842 29 36.8391 29 36.375C29 35.9109 29.1844 35.4658 29.5126 35.1376C29.8408 34.8094 30.2859 34.625 30.75 34.625C31.2141 34.625 31.6592 34.8094 31.9874 35.1376C32.3156 35.4658 32.5 35.9109 32.5 36.375C32.5 36.8391 32.3156 37.2842 31.9874 37.6124C31.6592 37.9406 31.2141 38.125 30.75 38.125Z",
    fill: "#555555"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyOnline);
export default __webpack_public_path__ + "static/media/buy-online.c7a2bcda6ccc7edd8d35cebd5b9422e2.svg";
export { ForwardRef as ReactComponent };